import { generateSchuecoProductValidationPreviewFromBackendInput } from '@p1/libs/schueco-product-validation/src/lib/model/schueco-product-validation.generators';

import { WatchlistElement } from './watchlist-element';
import { WatchlistElementBackend } from './watchlist-element.backend-interface';
import { WatchlistElementObjectType } from './watchlist-element-object-type.enum';
import { generateSupplierFromBackendInterface } from '../../../supplier/model/supplier.generators';
import { generateProductFromBackendInput } from '../../../product/model/product.generators';
import { generateProductComparisonFromBackendInput } from '../../../product-comparison/model/product-comparison.generators';
import { generateProductSavedQueryFromBackendInput } from '../../../product/model-saved-query/product-saved-query.generators';
import { generateProductspecificationPreviewFromBackendInterface } from '@p1/libs/productspecifications';


export const generateWatchlistElementFromBackendInput = (input: WatchlistElementBackend): WatchlistElement => {
  const watchlistElement: WatchlistElement = {
    uuid: input.Uuid,
    objectType: input.ObjectType as WatchlistElementObjectType,
    objectUuid: input.ObjectUuid
  };

  if (input.Sorting) {
    watchlistElement.sorting = input.Sorting;
  }

  if (input.Added) {
    watchlistElement.added = input.Added * 1000;
  }

  if (input.Comment) {
    watchlistElement.comment = input.Comment;
  }

  switch (input.ObjectType) {
    case WatchlistElementObjectType.Comparison:
      watchlistElement.object = generateProductComparisonFromBackendInput(input.Comparison);
      break;
    case WatchlistElementObjectType.Product:
      watchlistElement.object = generateProductFromBackendInput(input.Product);
      break;
    case WatchlistElementObjectType.Supplier:
      watchlistElement.object = generateSupplierFromBackendInterface(input.Supplier);
      break;
    case WatchlistElementObjectType.Query:
      watchlistElement.object = generateProductSavedQueryFromBackendInput(input.Query);
      break;
    case WatchlistElementObjectType.ProductValidation:
      watchlistElement.object = generateSchuecoProductValidationPreviewFromBackendInput(input.ProductValidation);
      break;
    case WatchlistElementObjectType.ProductSpecification:
      watchlistElement.object = generateProductspecificationPreviewFromBackendInterface(input.productspecification);
  }

  return watchlistElement;
};
